<template>
  <a name="about"></a>
  <div class="bg-verde-md conteudo_mov">
    <div class="content conteudo_mov2 border-log mt-5">
      <div class="row border-log">
        <div class="col-12 col-md-6 border-log p-4 left">
          <h1 class="cor-azul">AWA is a pure water sourced from the Amazon rainforest's atmosphere</h1>
        </div>
      </div>
      <div class="row border-log mt-5">
        <div class="amarelo col-12 col-md-6 f-4  p-4 border-log left">
          Born from the forest's breath and purified by trees over centuries, AWA is more than just water – it’s a movement toward a more conscious and sustainable way of life.
        </div>

        <div class="amarelo col-12 col-md-6 f-4  p-4 border-log left">
          Every drop is a commitment to preserving our roots and the renewal of our future. Join the movement where every sip helps regenerate our planet.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

.border-log {
      border: 0px solid rgb(0, 0, 255);
  }

.p-4 { padding: 1.5rem; }

.left {
  text-align: left;
}

.conteudo_mov {
  display: flex; /* Se já não estiver definido */
  justify-content: center;
}

.conteudo_mov2 {
    max-width: 172rem; 
    transition: max-width 0.3s ease-in-out;
    text-align: left;
    flex-grow: 1
}

.bg-verde-md {
  padding-top: 8rem; /* Removi o margin */
  padding-bottom: 8rem; /* Removi o margin */
  background-color: var(--mid-green);
  width: 100%; /* Garante que o fundo verde ocupe toda a largura da tela */
}

.cor-azul {
  color: var(--blue);
}

.amarelo {
  color: var(--cream);
}

h1 {
  font-family: var(--object-sans);
  font-size: 6rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
}


.f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  
.content {
  padding: 4rem; /* Reduzi o padding para 2rem, ajustando para não ficar tão grande */
  margin: 0; /* Removi o margin */
  text-align: left;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

@media screen and (max-width: 640px) {
  h1 {
    font-size: 4rem;
  }

  .p-4 { padding: 3rem; }

  .f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  .content {
    padding: 1rem; /* Ajustei o padding para ser menor em telas pequenas */
    margin: 0;
    text-align: left;
  }

  .row {
    flex-direction: column;
    text-align: center;
  }

  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
